export const SET_PROPERTIES = 'SET_PROPERTIES';
export const SET_PROPERTY = 'SET_PROPERTY';
export const SET_LOADING = 'SET_LOADING';
